import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import apiClient from '../api/axios';
import { toast } from 'react-toastify';

const ChangePasswordModal = ({ show, onHide }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isChanging, setIsChanging] = useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirmPassword) {
            setError('Новые пароли не совпадают.');
            return;
        }
        if (newPassword.length < 8) {
            setError('Новый пароль должен быть не менее 8 символов.');
            return;
        }

        setIsChanging(true);
        try {
            const response = await apiClient.put('/users/me/password', {
                current_password: currentPassword,
                new_password: newPassword
            });
            toast.success(response.data.message || 'Пароль успешно изменен!');
            handleClose();
        } catch (err) {
            // Обрабатываем ошибку валидации от FastAPI (422)
            if (err.response?.data?.detail && Array.isArray(err.response.data.detail)) {
                setError(err.response.data.detail[0].msg);
            } else {
                const errorMessage = err.response?.data?.detail || 'Произошла ошибка при смене пароля.';
                setError(errorMessage);
            }
        } finally {
            setIsChanging(false);
        }
    };

    const handleClose = () => {
        // Reset state on close
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setError('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Смена пароля</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleFormSubmit}>
                    <Form.Group className="mb-3" controlId="currentPasswordModal">
                        <Form.Label>Текущий пароль</Form.Label>
                        <Form.Control
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            required
                            autoFocus
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="newPasswordModal">
                        <Form.Label>Новый пароль</Form.Label>
                        <Form.Control
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                        <Form.Text className="text-muted">
                            Мин. 8 символов, 3 из 4 категорий: латинские буквы (a-z), прописные (A-Z), цифры (0-9), спецсимволы (!@#$%^&*()_+-=[]{}|).
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="confirmPasswordModal">
                        <Form.Label>Подтвердите новый пароль</Form.Label>
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Отмена
                </Button>
                <Button variant="primary" onClick={handleFormSubmit} disabled={isChanging}>
                    {isChanging ? 'Сохранение...' : 'Сменить пароль'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChangePasswordModal;